<ng-container *ngIf="product">
  <mat-tab-group [selectedIndex]="selectedTabIndex">
    <mat-tab label="Product Details">
      <div class="tab-content">
        <!-- Product Information -->
        <app-vendor-product-form
          [product]="product"
          (productSaved)="productSavedHandler()"
        ></app-vendor-product-form>
      </div>
    </mat-tab>

    <mat-tab [disabled]="stripeProductTabDisabled" label="Stripe Product Details">
      <div class="tab-content">
        <app-stripe-product-form
          (stripeProductSaved)="productSavedHandler()"
          (noStripeProduct)="disabeStripeProductTab()"
          (productIdChanged)="onProductIdChanged($event)"
          [billingCycles]="billingCycles"
          [stripeProductId]="product.stripeProductId"
        ></app-stripe-product-form>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- Brands -->
  <mat-tab-group *ngIf="subProjectProductId && subProjectProductId !== ''">
    <mat-tab label="Brands">
      <app-brands-table
        [subProjectProductId]="subProjectProductId"
        [billingCycles]="billingCycles"
      ></app-brands-table>
    </mat-tab>
  </mat-tab-group>
</ng-container>
